import httpClient from "Api/httpClient";

const END_POINT = "/sql/relationships";

const getSqlRelationships = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getSqlRelationship = (relation_id) => {
    if (!relation_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + relation_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printSqlRelationship = (relation_id) => {
    if (!relation_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?relation_id=" + relation_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createSqlRelationships = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateSqlRelationships = (payload, relation_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + relation_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteSqlRelationships = (relation_id) => {
    const DELETE_END_POINT = END_POINT + "/" + relation_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getSqlRelationships, getSqlRelationship, printSqlRelationship, createSqlRelationships, updateSqlRelationships, deleteSqlRelationships };
